import React, { useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import GavelIcon from '@mui/icons-material/Gavel';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const fontFamily = "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif";

const colors = {
  textPrimary: '#1e293b',
  textSecondary: '#475569',
  textTertiary: '#94a3b8',
  accent: '#f97316',
};

export default function Terms() {
  useEffect(() => {
    document.title = "Terms of Service | KlonIT Web Application";
  }, []);

  return (
    <Box sx={{ fontFamily, maxWidth: '900px', width: '100%', mx: 'auto' }}>
      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Box sx={{
          width: 56,
          height: 56,
          borderRadius: '16px',
          background: 'linear-gradient(135deg, #f97316, #ea580c)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2,
          boxShadow: '0 8px 24px rgba(249,115,22,0.3)',
        }}>
          <GavelIcon sx={{ color: '#fff', fontSize: 28 }} />
        </Box>
        <Typography sx={{ fontFamily, fontSize: '1.5rem', fontWeight: 700, color: colors.textPrimary, letterSpacing: '-0.02em' }}>
          Terms of Service
        </Typography>
        <Typography sx={{ fontFamily, fontSize: '0.875rem', color: colors.textTertiary, mt: 0.5 }}>
          Terms and conditions for using our services
        </Typography>
      </Box>

      {/* Content */}
      <Box sx={{
        bgcolor: 'rgba(255,255,255,0.8)',
        backdropFilter: 'blur(12px)',
        borderRadius: '16px',
        p: 4,
        border: '1px solid rgba(0,0,0,0.06)',
      }}>
        {/* View Full Terms Button */}
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            href="https://klonit.ai/terms-of-use"
            target="_blank"
            rel="noopener noreferrer"
            endIcon={<OpenInNewIcon />}
            sx={{
              fontFamily,
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '12px',
              px: 4,
              py: 1.25,
              background: 'linear-gradient(135deg, #f97316, #ea580c)',
              boxShadow: '0 4px 16px rgba(249,115,22,0.4)',
              '&:hover': { background: 'linear-gradient(135deg, #ea580c, #f97316)' },
            }}
          >
            View Full Terms of Service
          </Button>
        </Box>

        <Typography sx={{ fontFamily, fontSize: '1rem', fontWeight: 600, color: colors.textPrimary, mb: 2 }}>
          Key Definitions
        </Typography>

        {[
          { term: 'API', definition: 'KlonIT application programming interface to be integrated with the User\'s software.' },
          { term: 'Cookies', definition: 'Small files stored on your Device.' },
          { term: 'Device', definition: 'A computer or a mobile device.' },
          { term: 'Data Controller', definition: 'A natural or legal person who determines the purposes and manner of processing personal data.' },
          { term: 'Data Processors', definition: 'Any natural or legal person who processes the data on behalf of the Data Controller.' },
          { term: 'Personal Data', definition: 'Data about a living individual who can be identified from those data.' },
          { term: 'Service', definition: 'Together the Website, Widget and/or the API.' },
          { term: 'Usage Data', definition: 'Data collected automatically from the use of Service or Service infrastructure.' },
          { term: 'User', definition: 'The individual using our Service, corresponding to the Data Subject.' },
          { term: 'Website', definition: 'Web pages located at KlonIT.net.' },
          { term: 'Widget', definition: 'A KlonIT widget that may be implemented to the User\'s website.' },
        ].map((item, index) => (
          <Box key={index} sx={{
            p: 2,
            mb: 1.5,
            borderRadius: '10px',
            bgcolor: index % 2 === 0 ? 'rgba(249,115,22,0.05)' : 'transparent',
            border: '1px solid rgba(0,0,0,0.04)',
          }}>
            <Typography sx={{ fontFamily, fontSize: '0.85rem', fontWeight: 600, color: colors.accent, mb: 0.5 }}>
              {item.term}
            </Typography>
            <Typography sx={{ fontFamily, fontSize: '0.85rem', color: colors.textSecondary }}>
              {item.definition}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
